import {Section} from '..';
import {Typography} from '@material-ui/core';
import {AutoField} from '../fields';
import {useFieldData} from '../hooks';
import {getInitialValues, getSchema} from 'components/forms/AutoSection';

const Citizenship = ({
    sectionName,
    sectionFields,
    existingData,
    fieldDict,
    ...props
}) => {
    const schema = getSchema(sectionFields, fieldDict);
    const initialValues = getInitialValues(
        existingData,
        sectionFields,
        fieldDict
    );

    const [usCitizen, setUSCitizen] = useFieldData('applicant_us_citizen');
    const [legalAlien, setLegalAlien] = useFieldData('applicant_legal_alien');

    const updateLegalAlien = event => {
        setLegalAlien(event.target.value === 'true');
    };

    return (
        <Section {...props} schema={schema} initialValues={initialValues}>
            <Typography variant='h6' align='left'>
                {sectionName}
            </Typography>
            <AutoField
                field={fieldDict['applicant_us_citizen']}
                name='applicant_us_citizen'
                onChange={e => setUSCitizen(e.target.value === 'true')}
            />
            {(usCitizen === false || usCitizen === 'false') && (
                <AutoField
                    field={fieldDict['applicant_citizen_country']}
                    name='applicant_citizen_country'
                />
            )}
            {(usCitizen === false || usCitizen === 'false') && (
                <AutoField
                    field={fieldDict['applicant_legal_alien']}
                    name='applicant_legal_alien'
                    onChange={updateLegalAlien}
                />
            )}
            {(usCitizen === false || usCitizen === 'false') && legalAlien && (
                <AutoField
                    field={fieldDict['applicant_legal_alien_number']}
                    name='applicant_legal_alien_number'
                    required={legalAlien}
                />
            )}
        </Section>
    );
};

export default Citizenship;
